import React, { useRef, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import data from "../language.json";

function OtpVerify() {
  const inputRefs = useRef([]);
  const { lang, phone, setAlert, setMessage, setPhone } = useContext(languageContext);
  const [Otp, setOtp] = useState(new Array(6).fill(""));
  const [counter, setCounter] = useState(300);
  const navigate = useNavigate();
  const location = useLocation();
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const { from } = location.state || {};

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    setOtp([...Otp.map((d, idx) => (idx === index ? element.value : d))]);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !Otp[index]) {
      const newotp = [...Otp];
      newotp[index - 1] = "";
      inputRefs.current[index - 1].focus();
      setOtp(newotp);
    }
  };

  useEffect(() => {
    if (counter > 0) {
      const timer = setInterval(() => setCounter((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const verifyOtp = async () => {
    const otpValue = Otp.join("");
    if (otpValue.length !== 6) {
      setAlert(true);
      setMessage("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setVerifyingOtp(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/send_otp_verify",
        { phone, otp: otpValue },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.access_token || response.status === 200) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("login", true);
        localStorage.setItem("doctor_name", response.data.doctor_name)
        setPhone("");
        navigate(from === "signup" ? "/doctor-dashboard" : "/login");
      } else {
        setAlert(true);
        setMessage(response.data.msg || "OTP verification failed. Please try again.");
      }
    } catch (error) {
      setAlert(true);
      setMessage(error.response?.data?.msg || "OTP verification failed. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };

  return (
      <div className="flex flex-col items-center justify-center h-[calc(100vh-100px)] px-4">
        <div className="bg-white shadow-xl rounded-2xl p-8 w-full sm:w-[90%] md:w-[60%] lg:w-[28%] text-center">
          {/* Heading */}
          <h2 className="text-2xl font-bold text-blue-900">{data[lang]["auth"][2]}</h2>
          <p className="text-sm text-gray-600 mt-2">
            Enter the code sent to your registered mobile number
          </p>

          {/* OTP Inputs */}
          <div className="flex justify-center mt-6 space-x-3">
            {Otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                name={`otp-${index}`}
                maxLength={1}
                value={digit}
                autoFocus={index === 0}
                ref={(ref) => (inputRefs.current[index] = ref)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onChange={(e) => handleChange(e.target, index)}
                className="w-12 h-12 text-lg text-center rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none shadow-sm"
              />
            ))}
          </div>

          {/* Verify Button */}
          <button
            onClick={verifyOtp}
            disabled={verifyingOtp}
            className={`w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition-all ${
              verifyingOtp ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {verifyingOtp ? (
              <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto" />
            ) : (
              "Verify OTP"
            )}
          </button>

          {/* Timer */}
          <div className="mt-4 text-gray-600 text-sm">
            {counter > 0 ? (
              <p>Resend OTP in {formatTime(counter)}</p>
            ) : (
              <button
                className="text-blue-600 font-medium hover:underline"
                onClick={() => setCounter(300)}
              >
                Resend OTP
              </button>
            )}
          </div>

          {/* Back to login */}
          <div className="mt-4">
            <a href="/login" className="text-sm text-blue-500 hover:underline">
              Back to Login
            </a>
          </div>
        </div>
      </div>
    
  );
}

export default OtpVerify;
